var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('avp-breadcrumbs'), _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Pesquisar Instituição",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('avp-select-ativo', {
    attrs: {
      "cols": 2
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('avp-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarInstituicoes();
      }
    }
  }), _c('avp-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('avp-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterInstituicao();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listInstituicoes,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.nome`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nome) + " ")];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('avp-label-ativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('avp-tooltip', {
          attrs: {
            "text": 'Visualizar Instituição',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarInstituicao(item);
            }
          }
        }), _c('avp-tooltip', {
          attrs: {
            "text": 'Editar Instituição',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterInstituicao(item);
            }
          }
        }), _c('avp-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'} Instituição`,
            "icon": `${item.ativo ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarInstituicao(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarInstituicaoDialog', {
    attrs: {
      "visible": _vm.dialogManterInstituicao.visible,
      "content": _vm.dialogManterInstituicao.content,
      "edit": _vm.dialogManterInstituicao.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterInstituicao.close();
      },
      "onSave": function ($event) {
        return _vm.buscarInstituicoes();
      }
    }
  }), _c('VisualizarInstituicaoDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarInstituicao.visible,
      "content": _vm.dialogVisualizarInstituicao.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarInstituicao.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }